import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types'; // Importar PropTypes
import { useNavigate } from 'react-router-dom';
import { listarPropostas } from '../../services/propostaService';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  CircularProgress,
  Alert,
  Paper,
  Grid,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ChatIcon from '@mui/icons-material/Chat';

function PropostaList({ onOpenChat }) {
  const [propostas, setPropostas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPropostas = async () => {
      try {
        setLoading(true);
        const response = await listarPropostas();
        console.log('Resposta completa:', response); // Debug
        console.log('Dados das propostas:', response.data); // Debug
        setPropostas(Array.isArray(response.data) ? response.data : []);
        setError(null);
      } catch (err) {
        console.error('Erro detalhado ao carregar propostas:', err);
        setError('Não foi possível carregar as propostas. Por favor, tente novamente.');
      } finally {
        setLoading(false);
      }
    };

    fetchPropostas();
  }, []);

  // Renderiza estado de carregamento
  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#f5f5f5',
          p: 3,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Renderiza estado de erro
  if (error) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#f5f5f5',
          p: 3,
        }}
      >
        <Alert
          severity="error"
          sx={{ mb: 3, width: '100%', maxWidth: 600 }}
          action={
            <Button color="inherit" size="small" onClick={() => window.location.reload()}>
              Tentar Novamente
            </Button>
          }
        >
          {error}
        </Alert>
      </Box>
    );
  }

  // Renderiza lista vazia
  if (!propostas.length) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#f5f5f5',
          p: 3,
        }}
      >
        <Card sx={{ padding: 4, maxWidth: 600, textAlign: 'center' }}>
          <Typography variant="h5" gutterBottom>
            Nenhuma Proposta Encontrada
          </Typography>
          <Typography variant="body1" color="text.secondary" gutterBottom>
            Você ainda não tem propostas submetidas.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => navigate('/propostas/submeter')}
          >
            Submeter Nova Proposta
          </Button>
        </Card>
      </Box>
    );
  }

  // Renderiza lista de propostas com botão de chat
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        p: { xs: 2, sm: 4, md: 6 },
      }}
    >
      <Grid container justifyContent="center">
        <Grid item xs={12} md={10} lg={8}>
          <Card sx={{ padding: 3 }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 4,
              }}
            >
              <Typography variant="h4" component="h1">
                Lista de Propostas
              </Typography>
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => navigate('/propostas/submeter')}
              >
                Nova Proposta
              </Button>
            </Box>

            <Grid container spacing={3}>
              {propostas.map((proposta) => (
                <Grid item xs={12} key={proposta.id}>
                  <Paper
                    elevation={3}
                    sx={{
                      padding: 3,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 2,
                      '&:hover': {
                        boxShadow: 6,
                      },
                      transition: 'box-shadow 0.3s ease-in-out',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: 1,
                      }}
                    >
                      <Box>
                        <Typography variant="h6" component="h2">
                          {proposta.titulo}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Submetida em: {new Date(proposta.dataSubmissao).toLocaleDateString()}
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                          variant="outlined"
                          color="primary"
                          startIcon={<VisibilityIcon />}
                          onClick={() => navigate(`/propostas/${proposta.id}`)}
                        >
                          Ver Detalhes
                        </Button>
                        {onOpenChat && (
                          <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<ChatIcon />}
                            onClick={() => onOpenChat(proposta, 'projeto')}

                          >
                            Chat
                          </Button>
                        )}
                      </Box>
                    </Box>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

PropostaList.propTypes = {
  onOpenChat: PropTypes.func, // Validação da prop onOpenChat
};

export default PropostaList;
